"use client";

import { Typography } from "antd";
import { ReactNode } from "react";

type AntdTitleProps = {
  children: ReactNode;
  level?: 1 | 2 | 3 | 4 | 5;
  className?: string;
};

export default function AntdTitle({
  children,
  level = 2,
  className,
}: AntdTitleProps) {
  return (
    <Typography.Title level={level} className={className}>
      {children}
    </Typography.Title>
  );
}